import { FHIR_Observation_CategoryOptions, FHIR_Observation_StatusOptions } from './types/Observation/consts.js';
import { FHIR_Condition_CategoryOptions } from './types/Condition/consts.js';
import { FHIR_CreateRequest_Search_Extractor } from './const-extractors/search/search-extractor.js';
import { FHIR_Procedure_CategoryOptions } from './types/Procedure/consts.js';
import { FHIR_DocumentReference_CategoryOptions, FHIR_DocumentReference_DocStatusOptions, FHIR_DocumentReference_TypeOptions, } from './types/DocumentReference/consts.js';
import { FHIR_List_CodeOptions } from './types/List/consts.js';
import { FHIR_MedicationRequest_CategoryOptions, FHIR_MedicationRequest_StatusOptions } from './types/MedicationRequest/consts.js';
export const FHIR_CreateResourceExtractors = {
    AllergyIntolerance: FHIR_CreateRequest_Search_Extractor,
    Binary: FHIR_CreateRequest_Search_Extractor,
    Condition: FHIR_CreateRequest_Search_Extractor,
    DocumentReference: undefined, // Implemented in Advisor lib, as it requires performing an additional query
    FamilyMemberHistory: FHIR_CreateRequest_Search_Extractor,
    Immunization: FHIR_CreateRequest_Search_Extractor,
    List: FHIR_CreateRequest_Search_Extractor,
    MedicationRequest: FHIR_CreateRequest_Search_Extractor,
    Observation: FHIR_CreateRequest_Search_Extractor,
    Procedure: FHIR_CreateRequest_Search_Extractor,
};
export const ListOfFHIRQueryResources = {
    AllergyIntolerance: {
        patient: {
            type: 'dynamic', // dynamic means given on runtime, can't be hardcoded.
        },
        encounter: {
            type: 'dynamic',
        },
    },
    Binary: {
        _id: {
            type: 'dynamic'
        },
        patient: {
            type: 'dynamic'
        },
        encounter: {
            type: 'dynamic'
        }
    },
    Condition: {
        category: {
            type: 'mandatory', // mandatory means hardcoded in fhir query data object, must be pre-decided
            values: FHIR_Condition_CategoryOptions
        },
        patient: {
            type: 'dynamic',
        },
        encounter: {
            type: 'dynamic',
        },
    },
    DocumentReference: {
        category: {
            type: 'mandatory',
            values: FHIR_DocumentReference_CategoryOptions
        },
        docstatus: {
            type: 'mandatory',
            values: FHIR_DocumentReference_DocStatusOptions
        },
        type: {
            type: 'optional', // optional means it may not exist in the fhir query data object, is not mandatory for all queries for this resource
            values: FHIR_DocumentReference_TypeOptions
        },
        patient: {
            type: 'dynamic',
        },
        encounter: {
            type: 'dynamic',
        },
    },
    FamilyMemberHistory: {
        patient: {
            type: 'dynamic',
        }
    },
    Immunization: {
        patient: {
            type: 'dynamic',
        },
        encounter: {
            type: 'dynamic',
        },
    },
    List: {
        code: {
            type: 'optional',
            values: FHIR_List_CodeOptions
        },
        patient: {
            type: 'dynamic',
        },
        encounter: {
            type: 'dynamic',
        },
    },
    MedicationRequest: {
        category: {
            type: 'optional',
            values: FHIR_MedicationRequest_CategoryOptions
        },
        status: {
            type: 'optional',
            values: FHIR_MedicationRequest_StatusOptions
        },
        patient: {
            type: 'dynamic',
        },
        encounter: {
            type: 'dynamic',
        },
    },
    Observation: {
        category: {
            type: 'optional',
            values: FHIR_Observation_CategoryOptions
        },
        code: {
            type: 'optional',
            values: FHIR_Observation_StatusOptions
        },
        patient: {
            type: 'dynamic',
        },
        encounter: {
            type: 'dynamic',
        },
    },
    Procedure: {
        category: {
            type: 'mandatory',
            values: FHIR_Procedure_CategoryOptions
        },
        patient: {
            type: 'dynamic',
        },
        encounter: {
            type: 'dynamic',
        },
    },
};
//# sourceMappingURL=resources.js.map